import { Button } from '@/components/ui/button';
import { X, Users } from 'lucide-react';
import { cn } from '@/lib/utils';

interface Member {
  id: string;
  name: string;
  email: string;
}

interface MemberListProps {
  members: Member[];
  onRemove: (id: string) => void;
  isRemoving?: boolean;
  emptyMessage?: string;
}

export const MemberList = ({
  members,
  onRemove,
  isRemoving,
  emptyMessage = 'No members added yet.',
}: MemberListProps) => {
  if (members.length === 0) {
    return (
      <div className="rounded-lg border-2 border-dashed border-border py-8 text-center">
        <div className="w-8 h-8 rounded-full bg-muted flex items-center justify-center mx-auto mb-2">
          <Users className="w-4 h-4 text-muted-foreground" />
        </div>
        <p className="text-xs text-muted-foreground">{emptyMessage}</p>
      </div>
    );
  }

  return (
    <ul className="rounded-lg border border-border divide-y divide-border overflow-hidden">
      {members.map((m) => (
        <li
          key={m.id}
          className="flex items-center gap-3 px-3 py-2.5 bg-background hover:bg-muted/30 transition-colors"
        >
          <div className="w-7 h-7 rounded-full bg-primary/10 border border-primary/20 flex items-center justify-center shrink-0">
            <span className="text-[10px] font-bold text-primary">
              {m.name?.charAt(0).toUpperCase()}
            </span>
          </div>
          <div className="flex-1 min-w-0">
            <p className="text-sm font-medium text-foreground leading-tight truncate">
              {m.name}
            </p>
            <p className="text-xs text-muted-foreground truncate">{m.email}</p>
          </div>
          <Button
            type="button"
            variant="ghost"
            size="icon"
            className="h-7 w-7 text-muted-foreground hover:text-destructive hover:bg-destructive/10 shrink-0"
            disabled={isRemoving}
            onClick={() => onRemove(m.id)}
          >
            <X className="h-3.5 w-3.5" />
          </Button>
        </li>
      ))}
    </ul>
  );
};
